import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CoreModule } from '../core.module';

// Snitcher is a sales/marketing visitor-identification tool. It must only run on
// the sales pages, never inside the KLIC app or the admin area.
const EXCLUDED_ROUTE_PREFIXES = /^\/(?:klic|admin|projects|profile|export|veilig-graven|bestellen)(?:\/|[?#]|$)/;

@Injectable({
  providedIn: CoreModule,
})
export class SnitcherService {
  private added = false;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  public enableTracking(): void {
    if (environment.snitcher.enable === false || !isPlatformBrowser(this.platformId)) {
      return;
    }

    this.addTagUnlessExcluded(this.router.url);
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
      this.addTagUnlessExcluded(event.urlAfterRedirects);
    });
  }

  private addTagUnlessExcluded(url: string): void {
    if (this.added || EXCLUDED_ROUTE_PREFIXES.test(url)) {
      return;
    }
    this.added = true;
    this.addSnitcherTag();
  }

  // prettier-ignore
  private addSnitcherTag(): void {
    const script = document.createElement('script');
    script.text = `
      !function(e){"use strict";var t=e&&e.namespace;if(t&&e.profileId&&e.cdn){var i=window[t];if(i&&Array.isArray(i)||(i=window[t]=[]),!i.initialized&&!i._loaded)if(i._loaded)console&&console.warn("[Radar] Duplicate initialization attempted");else{i._loaded=!0;["track","page","identify","company","group","alias","ready","debug","on","off","once","trackClick","trackSubmit","trackLink","trackForm","pageview","screen","reset","register","setAnonymousId","addSourceMiddleware","addIntegrationMiddleware","addDestinationMiddleware","giveCookieConsent","denyCookieConsent"].forEach((function(e){var a;i[e]=(a=e,function(){var e=window[t];if(e.initialized)return e[a].apply(e,arguments);var i=[].slice.call(arguments);return i.unshift(a),e.push(i),e})})),-1===e.apiEndpoint.indexOf("http")&&(e.apiEndpoint="https://"+e.apiEndpoint),i.bootstrap=function(){var t,i=document.createElement("script");i.async=!0,i.type="text/javascript",i.id="__radar__",i.setAttribute("data-settings",JSON.stringify(e)),i.src=[-1!==(t=e.cdn).indexOf("http")?"":"https://",t,"/releases/latest/radar.min.js"].join("");var a=document.scripts[0];a.parentNode.insertBefore(i,a)},i.bootstrap()}}else"undefined"!=typeof console&&console.error("[Radar] Configuration incomplete")}({
        "apiEndpoint": "radar.snitcher.com",
        "cdn": "cdn.snitcher.com",
        "namespace": "Snitcher",
        "profileId": "${environment.snitcher.profileId}"
      });
    `;
    document.head.appendChild(script);
  }
}
